export default __webpack_public_path__ + "static/media/gallery_04.a2f5f406.jpg";